import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import './index.css';

class ConfirmationModal extends React.Component {

  render() {
    const {onCancel, onConfirm, message} = this.props;
    return (
      <Modal handleCloseClick={onCancel} className="modal--confirm">
        <div className="confirmationModal__body">
          <p className="confirmationModal__message">{message}</p>
          
          <div className="confirmationModal__actions">
            <a className="confirmationModal__button--cancel simple-link" onClick={onCancel}>Cancel</a>
            <a className="confirmationModal__button--confirm button button__hover button--green" onClick={onConfirm}>Confirm</a>
          </div>
        </div>
      </Modal>
    );
  }
}

ConfirmationModal.defaultProps = {
  onCancel: () => {},
  onConfirm: () => {},
  message: 'Confirm this action.'
};

ConfirmationModal.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  message: PropTypes.string
};

export default ConfirmationModal;



/** WEBPACK FOOTER **
 ** ./src/components/ConfirmationModal/index.js
 **/